import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import classnames from "classnames";

import { Button, Link } from "@lifepay/rc-ui-toolkit";

// import Badge from "components/visual/Badge";
// import Labeled from "components/visual/Labeled";
// import Details from "components/visual/Details";

import styles from "./Merchant.m.scss";

function Merchant(props) {
  const {
    theme,
    item,
    // selectedMerchant,
    // selectMerchant,
    goToCompanies,
    goToTerminals,
    goToTransactions,
  } = props;
  return (
    <div
      className={classnames(
        theme.wrapper
        // selectedMerchant && selectedMerchant.id === item.id && theme.active
      )}
      // onClick={() => selectMerchant(item)}
    >
      <div>{item.id}</div>
      <div>{item.merchantName}</div>
      <div>{item.address}</div>
      <div>{item.city}</div>
      <div>{item.zipCode}</div>
      <div>
        {item.companyId ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToCompanies({
                search: `company-id=${item.companyId}`,
                state: {
                  routerStateQuery: {
                    companyId: item.companyId,
                  },
                },
              })
            }
          >
            {item.companyId}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <div>
        {item.companyName ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToCompanies({
                search: `company-name=${item.companyName}`,
                state: {
                  routerStateQuery: {
                    companyName: item.companyName,
                  },
                },
              })
            }
          >
            {item.companyName}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            goToTerminals({
              search: `?merchant-id=${item.id}`,
              state: {
                routerStateQuery: {
                  merchantId: item.id,
                },
              },
            })
          }
        >
          {"Терминалы"}
        </Button>
      </div>
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() =>
            goToTransactions({
              search: `?merchant-id=${item.id}`,
              state: {
                routerStateQuery: {
                  merchantId: item.id,
                },
              },
            })
          }
        >
          {"Транзакции"}
        </Button>
      </div>
    </div>
  );
}

Merchant.displayName = "Merchant";

Merchant.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
  selectedMerchant: PropTypes.object,
  selectMerchant: PropTypes.func,
  goToTerminals: PropTypes.func,
  goToCompanies: PropTypes.func,
  goToTransactions: PropTypes.func,
};

Merchant.defaultProps = {};

export default withRouter(themr("@lifepay/Merchant", styles)(Merchant));



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Merchant/Merchant.js